import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

/**
 * Reveal — subtle scroll-triggered entrance animation.
 *
 * Editorial leadership: short distance (16px), gentle ease, runs once.
 * Use `delay` to stagger sibling reveals.
 */
export const Reveal = ({
  children,
  delay = 0,
  y = 12,
  amount = 0.2,
  className,
  as = "div",
  testId,
}) => {
  const reduced = usePreferStaticUI();
  const Tag = as;

  if (reduced) {
    return (
      <Tag className={className} data-testid={testId}>
        {children}
      </Tag>
    );
  }

  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.5, ease: [0.22, 0.61, 0.36, 1], delay }}
      className={className}
      data-testid={testId}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
